export * from './dlg-store-pixel.component';
